import { render, staticRenderFns } from "./LeagueMapping.vue?vue&type=template&id=273af0ce&scoped=true&"
import script from "./LeagueMapping.vue?vue&type=script&lang=js&"
export * from "./LeagueMapping.vue?vue&type=script&lang=js&"
import style0 from "./LeagueMapping.vue?vue&type=style&index=0&id=273af0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273af0ce",
  null
  
)

export default component.exports